import { Modal, P, Input, Gap } from '@salecycle/ui-component-library';
import { useTranslation } from 'react-i18next';
import { useTemplateEditorDispatch } from '../../context/UseTemplateEditorContext';
import { useState } from 'react';

interface IProps {
  validationMessage: string;
  onsiteValidationMessageModalOpen: boolean;
  setOnsiteValidationMessageModalOpen(isOpen: boolean);
}

export const TemplateEditorOnsiteValidationModal = ({
  validationMessage,
  onsiteValidationMessageModalOpen,
  setOnsiteValidationMessageModalOpen,
}: IProps) => {
  const { t } = useTranslation('trackingLinks');
  const [localValidationMessage, setValidationMessage] = useState(validationMessage ?? '');
  const dispatch = useTemplateEditorDispatch();

  const handleClose = () => {
    setOnsiteValidationMessageModalOpen(false);
  };

  const handleConfirm = () => {
    setOnsiteValidationMessageModalOpen(false);
    dispatch({
      type: 'SET_ONSITE_VALIDATION_MESSAGE',
      payload: {
        onsiteValidationMessage: localValidationMessage,
      },
    });
    dispatch({
      type: 'SET_UNSAVED_CHANGES',
      payload: { hasUnsavedChanges: true },
    });
  };

  return (
    <Modal
      heading="Onsite Message Validation Feedback"
      variation="clean"
      isOpen={onsiteValidationMessageModalOpen}
      onCancelButtonClicked={handleClose}
      onCloseButtonClicked={handleClose}
      onOkButtonClicked={handleConfirm}
      okButtonLabel={t('trackingLinks:importSessionModal.confirm')}
      cancelButtonLabel={t('trackingLinks:importSessionModal.cancel')}
    >
      <P>Please enter a validation message for the visitor in the language for the given template:</P>
      <Gap top={20} />
      <Input
        value={localValidationMessage}
        onChange={setValidationMessage}
        ariaLabel="Validation Message"
        label="Validation Message"
        placeholder="Validation Message"
        tooltipHeading="Enter desired validation message for template"
        tooltipDescription="The validation message that will appear if a visitor tries to submit an onsite message without sufficient information entered."
        data-testid="validationmessageinput"
      />
    </Modal>
  );
};
